export enum SortDirection {
    ASCENDING = 'asc',
    DESCENDING = 'desc'
}